import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/Home.vue'
import Layout from '../views/Layout/Layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login/login.vue'),
    children: []
  },
  {
    path: '/middle',
    name: 'transferPage',
    component: () => import('@/views/Login/transferPage.vue'),
    children: []
  },
  {
    path: '/',
    component: Layout,
    redirect: '/layout',
    hidden: true,
  },
  {
    path: '/layout',
    name: 'Layout',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'Home',
        component: Home,
      },
      {
        path: '/request-list',
        name: 'Request List',
        component: () => import('../views/RequestList/RequestList')
      },
      {
        path: '/task-list',
        name: 'Task List',
        component: () => import('../views/RequestList/RequestList')
      },
      {
        path: '/request-list/raise-new-case',
        name: 'Raise a new case',
        component: () => import('../views/RaiseNewCase/RaiseNewCase')
      },
      {
        path: '/request-list/case-detail',
        name: 'Case Detail',
        component: () => import('../views/RaiseNewCase/RaiseNewCase')
      }, // TestPage
      {
        path: '/task-list/task-detail',
        name: 'Task Detail',
        component: () => import('../views/CFDetail/CFPageDetail')
      },
    ]
  },

  {
    path: '/test',
    name: 'test Page',
    component: () => import('../views/TestPage/TestPage')
  },{
    path: '/pdf',
    name: 'PDF Page',
    component: () => import('../views/PdfView/PDFView')
  },
  {
    path: '/404',
    name: 'Error',
    component: () => import('../views/Error/404')
  },
  {path: '*', redirect: '/404', hidden: true}
];
export const asyncRouterMap = [

];

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
